import React from 'react'
import { Modal, Button } from 'react-bootstrap'

const CommentModal = ({ show, comment, onClose }) => (
  <Modal
    show={show}
    onHide={onClose}
    backdrop="static"
    dialogClassName="commentModal modal-dialog-centered"
  >
    <Modal.Header closeButton>
      <Modal.Title>Report Comment</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{comment || 'No Comments'}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onClose}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
)

export default CommentModal
